/*  */

//*componentes-utiles
//*datos

//*clases

//*componente
    export default function PaginaMenu5() {
    return (
        <div className="container container-Vista" >
        <h1>Página menu 5</h1>
        <br></br>
        </div>
    );
    }
